<div class="row col-12 padding-left-0 padding-right-0">
    <div class="row col-12">
        <div class="col-3 bold padding-left-0"></div>
        <div class="col-2 bold padding-left-0">Amount</div>
        <div class="col-2 bold padding-left-0">Due Date</div>
        <div class="col-2 bold padding-left-0">Status</div>
        <div class="col-3 bold padding-left-0">Action</div>
    </div>
</div>
<div *ngFor="let matterInvoice of matterInvoices" class="padding-bottom-5 padding-top-5 border-bottom">
    <div class="row col-12 padding-left-0 padding-right-0">
        <div class="row col-12 cursor-pointer">
            <div class="col-3 padding-left-0">
                <a href='#' (click)="downloadInvoice(matterInvoice, $event)">Statement: {{matterInvoice.id}}</a>
            </div>
            <div class="col-2 padding-left-0">{{matterInvoice.invoiceAmount | currency}}
            </div>
            <div class="col-2 padding-left-0">{{matterInvoice.dueDate | date}}</div>
            <div class="col-2 padding-left-0">{{mapStatus(matterInvoice.status)}}</div>
            <div class="col-3 padding-left-0">
                <a *ngIf="!paymentHasError(matterInvoice.status)" href="#"
                    (click)="redirectToPaymentUrl(matterInvoice, $event)">{{getPaymentLinkText(matterInvoice.status)}}</a>
                <span *ngIf="paymentHasError(matterInvoice.status)">{{getPaymentLinkText(matterInvoice.status)}}</span>
            </div>
        </div>
    </div>
</div>